import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';

const { FiHome, FiUser, FiGrid } = FiIcons;

const MobileBottomNav = () => {
  const location = useLocation();
  const { user } = useAuth();

  // Define navigation items (only Home and Account/Login remain)
  const navItems = [
    { path: '/', label: 'Home', icon: FiHome },
    { path: user ? '/dashboard' : '/login', label: user ? 'Account' : 'Login', icon: user ? FiGrid : FiUser }
  ];

  // Limit to 5 items to fit screen comfortably (only 2 remain)
  const displayItems = navItems.slice(0, 5);

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white/90 backdrop-blur-lg border-t border-gray-200 z-50 pb-safe">
      <div className="flex justify-around items-center h-16">
        {displayItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex-1 flex flex-col items-center justify-center h-full active:scale-95 transition-transform"
            >
              <div className={`relative p-1.5 rounded-xl transition-colors ${isActive ? 'bg-yellow-50' : 'bg-transparent'}`}>
                <SafeIcon icon={item.icon} className={`text-2xl ${isActive ? 'text-yellow-500' : 'text-gray-400'}`} />
                {isActive && (
                  <motion.div layoutId="nav-indicator" className="absolute -bottom-1 left-1/2 transform -translate-x-1/2 w-1 h-1 bg-yellow-500 rounded-full" />
                )}
              </div>
              <span className={`text-[10px] font-medium mt-0.5 ${isActive ? 'text-yellow-600' : 'text-gray-500'}`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileBottomNav;